(function () {
    'use strict';

    var SPINNER_HTML =
        '<div class="col-span-full flex justify-center py-8">' +
        '<svg class="animate-spin h-6 w-6 text-gray-400" fill="none" viewBox="0 0 24 24">' +
        '<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>' +
        '<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>' +
        '</svg></div>';

    var GEO_TTL_MS = 5 * 60 * 1000; // 5 minutos

    function getGeoCoords() {
        return new Promise(function (resolve) {
            var lat = parseFloat(localStorage.getItem('mt_geo_lat'));
            var lng = parseFloat(localStorage.getItem('mt_geo_lng'));
            var ts  = parseInt(localStorage.getItem('mt_geo_ts'), 10);
            var vigente = !isNaN(ts) && (Date.now() - ts) < GEO_TTL_MS;

            if (!isNaN(lat) && !isNaN(lng) && vigente) return resolve({ lat: lat, lng: lng });

            // Caché caducada o inexistente: la limpiamos y volvemos a pedir la geolocalización.
            localStorage.removeItem('mt_geo_lat');
            localStorage.removeItem('mt_geo_lng');
            localStorage.removeItem('mt_geo_ts');

            if (!navigator.geolocation) return resolve(null);
            navigator.geolocation.getCurrentPosition(
                function (pos) {
                    localStorage.setItem('mt_geo_lat', pos.coords.latitude);
                    localStorage.setItem('mt_geo_lng', pos.coords.longitude);
                    localStorage.setItem('mt_geo_ts', Date.now());
                    resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude });
                },
                function () { resolve(null); },
                { timeout: 5000, maximumAge: 300000 }
            );
        });
    }

    function filtrarTiendas() {
        var tipo      = document.getElementById('home-filtro-tipo').value;
        var genero    = document.getElementById('home-filtro-genero').value;
        var plaza     = document.getElementById('home-filtro-plaza').value;
        var container = document.getElementById('home-tiendas-container');
        container.innerHTML = SPINNER_HTML;

        getGeoCoords().then(function (geo) {
            var data = { filtro_tipo: tipo, filtro_genero: genero, filtro_plaza: plaza };
            if (geo) { data.lat = geo.lat; data.lng = geo.lng; }

            $.ajax({
                url: window.MT_TIENDAS_HOME_URL,
                type: 'GET',
                data: data,
                success: function (html) { container.innerHTML = html; },
                error: function () {
                    container.innerHTML =
                        '<p class="col-span-full text-center text-gray-400 py-8 text-sm">Error al cargar las tiendas.</p>';
                }
            });
        });
    }

    function actualizarVisibilidadMercado() {
        var tipo = document.getElementById('home-filtro-tipo').value;
        var wrap = document.getElementById('home-filtro-mercado-wrap');
        if (tipo === 'Puesto en mercado o plaza') {
            wrap.style.display = '';
        } else {
            wrap.style.display = 'none';
            document.getElementById('home-filtro-plaza').value = '';
        }
    }

    window.homeFiltrarTiendas  = filtrarTiendas;

    window.homeLimpiarFiltros = function () {
        document.getElementById('home-filtro-tipo').value   = '';
        document.getElementById('home-filtro-genero').value = '';
        document.getElementById('home-filtro-plaza').value  = '';
        actualizarVisibilidadMercado();
        filtrarTiendas();
    };

    document.addEventListener('DOMContentLoaded', function () {
        var panel = document.getElementById('home-filtros-panel');
        var btn   = document.getElementById('home-filtros-btn');

        if (!panel || !btn) return;

        function posicionarPanel() {
            var rect = btn.getBoundingClientRect();
            panel.style.top  = (rect.bottom + 8) + 'px';
            panel.style.left = (rect.right - 280) + 'px';
        }

        btn.addEventListener('click', function (e) {
            e.stopPropagation();
            if (panel.classList.contains('hidden')) {
                posicionarPanel();
                panel.classList.remove('hidden');
            } else {
                panel.classList.add('hidden');
            }
        });

        document.addEventListener('click', function (e) {
            if (!panel.contains(e.target) && e.target !== btn) {
                panel.classList.add('hidden');
            }
        });

        window.addEventListener('scroll', function () {
            if (!panel.classList.contains('hidden')) posicionarPanel();
        }, { passive: true });

        document.getElementById('home-filtro-tipo').addEventListener('change', function () {
            actualizarVisibilidadMercado();
            filtrarTiendas();
        });
        document.getElementById('home-filtro-genero').addEventListener('change', filtrarTiendas);
        document.getElementById('home-filtro-plaza').addEventListener('change', filtrarTiendas);

        // Carga inicial
        filtrarTiendas();
    });
}());
